import React from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { productsPerPageWebsite, productsPerPageMobile, maxVisiblePages } from '../../app/constants';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Function to update products per page based on screen size
    const updateProductsPerPage = () => {
      if (window.innerWidth >= 1024) {
        dispatch({ type: 'wholesaler/setProductsPerPage', payload: productsPerPageWebsite });
      } else if (window.innerWidth >= 640) {
        dispatch({ type: 'wholesaler/setProductsPerPage', payload: productsPerPageMobile });
      } else {
        dispatch({ type: 'wholesaler/setProductsPerPage', payload: productsPerPageMobile });
      }
    };
    updateProductsPerPage();
    window.addEventListener('resize', updateProductsPerPage);
    // Cleanup
    return () => {
      window.removeEventListener('resize', updateProductsPerPage);
    };
  }, [dispatch]);

  
  const pageNumbers = [];
  const maxPages =maxVisiblePages;

  // Calculate the range of page numbers to display
  let startPage = Math.max(1, currentPage - Math.floor(maxPages / 2));
  let endPage = Math.min(totalPages, startPage + maxPages - 1);

  // Adjust start page if we're near the end
  if (endPage - startPage + 1 < maxPages) {
    startPage = Math.max(1, endPage - maxPages + 1);
  }

  // Generate page numbers
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="flex justify-center items-center space-x-2">
      {/* Previous Button */}
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`px-3 py-1 rounded-md ${
          currentPage === 1
            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
            : 'bg-white text-gray-700 hover:bg-gray-50'
        }`}
      >
        Previous
      </button>

      {/* First Page */}
      {startPage > 1 && (
        <>
          <button
            onClick={() => onPageChange(1)}
            className={`px-3 py-1 rounded-md ${
              currentPage === 1
                ? 'bg-yellow-500 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-50'
            }`}
          >
            1
          </button>
          {startPage > 2 && <span className="text-gray-500">...</span>}
        </>
      )}

      {/* Page Numbers */}
      {pageNumbers.map((number) => (
        <button
          key={number}
          onClick={() => onPageChange(number)}
          className={`px-3 py-1 rounded-md ${
            currentPage === number
              ? 'bg-yellow-500 text-white'
              : 'bg-white text-gray-700 hover:bg-gray-50'
          }`}
        >
          {number}
        </button>
      ))}

      {/* Last Page */}
      {endPage < totalPages && (
        <>
          {endPage < totalPages - 1 && <span className="text-gray-500">...</span>}
          <button
            onClick={() => onPageChange(totalPages)}
            className={`px-3 py-1 rounded-md ${
              currentPage === totalPages
                ? 'bg-yellow-500 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-50'
            }`}
          >
            {totalPages}
          </button>
        </>
      )}

      {/* Next Button */}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`px-3 py-1 rounded-md ${
          currentPage === totalPages
            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
            : 'bg-white text-gray-700 hover:bg-gray-50'
        }`}
      >
        Next
      </button>
    </div>
  );

};

export default Pagination; 